<template>
  <div class="tab-item pt-0">
    <div v-if="item.contrainte_classement" class="text-lg pb-4">{{item.contrainte_classement}}</div>
    <template
      v-if="
        (item.categorized_classifications &&
          Object.keys(item.categorized_classifications.classifications)
            .length) ||
        Number(item.cmr)
      "
    >
    <!-- v-if="sorted_picto.length || Number(item.cmr)" -->
      <div
        class="flex flex-wrap gap-8 items-center mb-6"
      >
        <figure v-for="(picto, key) in sorted_picto" :key="key" class="has-tooltip">
          <img
            :src="require(`@/assets/images/picto/${picto.code_picto}.jpg`)"
            :alt="picto"
          />
          <figcaption class="text-center">
            {{ picto.code_picto }}
          </figcaption>
          <span class="tooltip">{{ picto.comment }}</span>
        </figure>
        <div class="flex flex-wrap align-center gap-4 mb-6 ml-4">
          <div class="font-bold uppercase">
            {{
              item.categorized_classifications.warnings
                .filter(Boolean)
                .join(' / ')
                .toUpperCase()
            }}
          </div>
          <p class="font-bold">{{ cmr }}</p>
        </div>
      </div>

      <div
        class="tableau mentions-dangers"
        v-for="(classification, classificationKey) in item
          .categorized_classifications.classifications"
        :key="classificationKey"
      >
        <div class="big-table">
          <h2>{{ classificationKey }}</h2>
        </div>
        <div class="tableau_corps">
          <div
            class="big-table_row"
            v-for="(
              subClassification, subClassificationKey
            ) in sortSubClassifications(classification, classificationKey)"
            :key="subClassificationKey"
          >
            <h4>
              {{ subClassificationKey }}
            </h4>
            <div
              v-for="danger in subClassification"
              :key="danger.code"
              class="grid grid-cols-1 sm:grid-cols-12 my-2"
            >
              <div class="col-span-3 text-gris">
                {{ getStringBeforeDot(danger.code) }}
              </div>
              <div class="col-span-9">{{ danger.comment }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else-if="item.types == 'Macro-organisme' && item.categorized_classifications.warnings == '' " class="detail-page-block">
      <p> Les macro-organismes ne sont pas concernés par la classification CLP. </p>
    </div>
    <div v-else-if="item.type == 'Macro-organisme' && item.categorized_classifications.warnings == '' " class="detail-page-block">
      <p> Les macro-organismes ne sont pas concernés par la classification CLP. </p>
    </div>
    <div v-else-if="verbose === 'ce produit'" class="detail-page-block">
      <p class="uppercase font-bold">Non classé</p>
    </div>
    <div v-else-if="verbose === 'cette substance'" class="detail-page-block">
      <p> Pas de donnée de classification pour cette substance.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailClassifications',

  props: {
    verbose: String,
    item: Object
  },
  computed: {
    sorted_picto: function () {
      if (
        this.item.categorized_classifications.pictograms.filter(Boolean).length
      ) {
        return this.item.categorized_classifications.pictograms
          .filter(Boolean)
          .sort()
      } else return []
    },

    cmr () {
      return this.cmrMap[this.item.cmr] || ''
    },

    cmrMap () {
      return {
        0: '',
        1: 'CMR catégorie 1',
        2: 'CMR catégorie 2',
        3: 'CMR catégorie 1/2 (DPD)',
        4: 'CMR catégorie 3 (DPD)',
        5: 'CMR catégorie 1 - effet sur / via allaitement',
        6: 'CMR catégorie 2 - effet sur / via allaitement',
        7: 'Effet sur / via allaitement',
        
      }
    }
  },
  methods: {
    sortSubClassifications (subClassifications, classificationKey) {
      const sequence = classificationsSequences[classificationKey]
      if (!sequence) return subClassifications

      const sortedSubClassificationsArray = sequence
        .filter((x) => subClassifications[x])
        .map((x) => [x, subClassifications[x]])

      const sortedSubClassifications = Object.fromEntries(
        sortedSubClassificationsArray
      )
      return sortedSubClassifications
    },

    getStringBeforeDot (str = '') {
      const newStr = str.split('.')[0]
      return newStr
    }
  }
}

const classificationsSequences = {
  'Mentions de danger (phrases H) et informations additionnelles (phrases EUH)':
    [
      'Dangers physiques',
      'Dangers pour la santé',
      "Dangers pour l'environnement",
      'Éléments supplémentaires'
    ],
  'Conseils de prudence (phrases P)': [
    'Conseils généraux',
    'Prévention',
    'Intervention',
    'Stockage',
    'Élimination'
  ],
  'Phrases types – mesures de sécurité (phrases SP)': [
    'Générales',
    "Pour l'environnement",
    'Pour les opérateurs',
    'Bonnes pratiques agricoles',
    'Rodenticides'
  ]
}
</script>
